import { Component, inject } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink],
  templateUrl: './components/app/app.component.html',
  styleUrl: './components/app/app.component.css'
})
export class AppComponent {
  userService = inject(UserService);
}